<template>


    <div style="background-color: #FAFAFA;">

        <div style="margin: auto; max-width: 55em">
            <img src="https://storage.googleapis.com/vetvise.appspot.com/public_assets/paper.png"
                 alt="Logo Tiernotfall-App auf einem Bild mit einem Hundewelpen und einem Katzenjungen"
                 style="margin: auto; width:100%; height: auto; max-width: 55em"/>
        </div>

        <!-- body-->
        <div class="card" style="margin: auto; max-width: 54em; margin-top: 1em;">
            <h1 align="center" style="color: #005A9F">TiHo vets for pets</h1>
            <img src="resources/tiho_logo.png" alt="" align="right"
                 style="max-width: 10em; margin: 0em; margin-left: 1em; margin-bottom: 1em">
            <p style="">Liebe Tierfreundin,<br>lieber Tierfreund,</p>

            <p>In diesen besonderen Zeiten wollen wir, die Kleintierklinik der Tierärztlichen Hochschule, weiterhin
                möglichst gut für Sie und Ihr Tier im Dienst sein. Deshalb bieten wir Ihnen gemeinsam mit dem Startup
                vetvise die Möglichkeit, per Videogespräch uns Fragen stellen zu können.</p>
            <p>Sie brauchen hierfür einen Computer mit Webcam, Headset und aktuellem Browser. Alternativ ein Smartphone.
                Bitte klicken sie hierfür auf den folgenden Link.</p>
            <p><a href="https://tna.vetvise.com" target="_blank" class="links">tiernotfallapp.de</a></p>
            <p>Bitte beachten Sie, dass es sich um eine Testphase zu wissenschaftlichen Zwecken handelt, bei der noch
                Fehler auftreten können. Deshalb kostet dies momentan weder etwas für die Nutzung der Plattform
                (“vetvise-Gebühr”) noch für die tierärztliche Ratschläge.</p>
            <p><b>Bitte suchen Sie im akuten Notfall oder bei unklaren Fällen immer direkt einen Tierarzt vor Ort
                auf.</b></p>
            <p>Nehmen Sie hierfür entweder Kontakt zu Ihrem Haustierarzt auf, kommen Sie in die Kleintierklinik der
                Tierärztlichen Hochschule Hannover oder finden Sie einen anderen Tierarzt in der Suche des
                Bundesverbandes praktizierender Tierärzte:</p>
            <p><a href="https://www.bpt-tierarztsuche.de/" target="_blank" class="links">https://www.bpt-tierarztsuche.de/</a>
            </p>
            <p style="margin-top: 2em">Herzlichst</p>

            <p style="font-style: italic">Das Team der <a
                    href="https://www.tiho-hannover.de/kliniken-institute/kliniken/klinik-fuer-kleintiere/"
                    target="_blank" class="links">Kleintierklinik der Tierärztlichen Hochschule Hannover</a></p>
            <p style="font-style: italic">Das Team der <a href="https://vetvise.com" target="_blank" class="links">Tiernotfall-App</a>
            </p>


            <!-- Footer within Body-->


            <div>
                <a class="links" href="url" target="_blank" style="margin-right: 1em; font-size: 0.7em">Impressum</a>
                <a class="links" href="url" target="_blank" style="margin-right: 1em; font-size: 0.7em">Nutzungsbedingungen</a>
                <a class="links" href="url" target="_blank" style="font-size: 0.7em">Datenschutzerklärung</a>
            </div>

            <!-- Footer within Body end-->

        </div>
        <!--Body end-->

        <!-- footer -->
        <div style="margin-top: 2em">
            <p style="text-align: center; font-size: 0.7em">Entwickelt von:</p>
            <a href="https://vetvise.com" target="_blank" class="links">
                <img src="https://storage.googleapis.com/vetvise.appspot.com/public_assets/logo_big.png"
                     alt="Logo vetvise"
                     style="display: block;margin-left: auto; margin-right: auto; margin-top: 1em; width: auto; height: 4em">
            </a>

        </div>

        <!--footer end-->

    </div>
</template>

<script>
    export default {
        name: "Tiho"
    }
</script>

<style scoped>
    h2 {
        color: #54B0E4;
        text-align: center;
        margin-left: auto;
        margin-right: auto
    }

    body {
        font-family: 'Quicksand Light', sans-serif;
        font-size: 18px;
        font-weight: lighter;
        text-align: justify;
    }

    .card {
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
        border-radius: 5px; /* 5px rounded corners */
        background-color: white;
        padding: 0.5em
    }

    .links:link {
        color: #54B0E4;
    }
</style>